import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface OtherBusinessesInputProps {
  // Controlled pattern (used by JourneyPage)
  value?: { other_businesses?: string | null };
  onChange?: (val: { other_businesses: string }) => void;
  disabled?: boolean;
  // Legacy pattern
  initialData?: { other_businesses?: string };
  onDataChange?: (data: { other_businesses: string }) => void;
}

const OTHER_BUSINESSES_OPTIONS = [
  { value: 'one', label: 'One' },
  { value: 'twoToThree', label: 'Two to Three' },
  { value: 'threeOrMore', label: 'Three or More' }
];

const OtherBusinessesInput: React.FC<OtherBusinessesInputProps> = ({
  value,
  onChange,
  disabled,
  initialData,
  onDataChange,
}) => {
  const currentValue = (value?.other_businesses ?? initialData?.other_businesses ?? '') || '';

  const handleChange = useCallback((val: string) => {
    onChange?.({ other_businesses: val });
    onDataChange?.({ other_businesses: val });
  }, [onChange, onDataChange]);

  return (
    <div className="space-y-1.5">
      <Label className="text-gray-500 font-medium">Number of Other Businesses</Label>
      <Select value={currentValue || undefined} onValueChange={handleChange} disabled={disabled}>
        <SelectTrigger className="border-gray-200 focus:border-intellend-green focus:ring-intellend-green rounded-xl py-6">
          <SelectValue placeholder="Select number of businesses" />
        </SelectTrigger>
        <SelectContent>
          {OTHER_BUSINESSES_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default OtherBusinessesInput;
